import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { registerServiceWorker } from './pwa/register';
import { createAppRouter } from './router';
import { useOfflineStore } from './stores/offline';
import './styles/global.css';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
// Lot AW : hors connexion (données gardées sur le téléphone, changements en attente), avant le premier appel.
useOfflineStore(pinia).install();
app.use(createAppRouter(pinia));
app.mount('#app');
registerServiceWorker();
